/* eslint-disable import/prefer-default-export */
export const GET_DEDICATED_CUSTOMERS_URL = `https://legacy.tizeti.com/geniatechapi/index.php`;
export const SEARCH_DEDICATED_CUSTOMERS_URL = `https://legacy.tizeti.com/geniatechapi/index.php`;
export const GET_BIZDEV_USERS = `https://api.tizeti.com/api/v1/busdevuser/getUsers`
